<template>
    <!--顯示 由menu param 傳來的 memo參數-->
    <v-flex >
        <div style="white-space: pre-line" v-html="memo"></div>

        <v-dialog v-model="alertDialog"
                  persistent
                  :width="dialogWidth+'%'"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <alert-win @closeDialog="closeDialog" @confirm="closeDialog" :alery-type="alertType"  :alert-title="alertTitle" :alert-msg="alertContent" ></alert-win>
        </v-dialog>
    </v-flex>
</template>

<script>
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "MemoPage",
        components:{AlertWin},
        data() {
            return {
                memo: '',
                alertDialog:false,
                alertType:'default',
                alertTitle:'訊息',
                alertContent:'',

            }
        },
        created(){
            this.memo =  this.$route.params.memo;
            this.alertContent = this.memo;
            this.alertDialog = true;
        },
        methods:{
            closeDialog(){
                this.alertDialog =false;
            },
        },
        computed:{
            dialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {return width = 100}
                if(this.$vuetify.breakpoint.sm == true){return width = 97}
                if(this.$vuetify.breakpoint.md == true){return width = 55}
                if(this.$vuetify.breakpoint.lg == true){return width = 45}
                if(this.$vuetify.breakpoint.xl ==true){return width = 40}
                return  width
            },
        },

    }
</script>

<style scoped>

</style>